"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-change-log-diff-node.component.scss");
var lodash_1 = require("lodash");
var SisChangeLogDiffTreeNodeComponent = /** @class */ (function () {
    function SisChangeLogDiffTreeNodeComponent() {
        this.linked = false;
        this.createVersion = false;
    }
    SisChangeLogDiffTreeNodeComponent.prototype.isDataRow = function () {
        return !lodash_1.isNil(this.dataRow);
    };
    SisChangeLogDiffTreeNodeComponent.prototype.isExpandable = function () {
        return (!lodash_1.isNil(this.group) ||
            !lodash_1.isNil(this.subGroup) ||
            (this.isDataRow() && !this.isDataRowWithoutSubs()));
    };
    SisChangeLogDiffTreeNodeComponent.prototype.isExpanded = function () {
        return ((!lodash_1.isNil(this.group) && this.group.expanded) ||
            (!lodash_1.isNil(this.subGroup) && this.subGroup.expanded) ||
            (this.isDataRow() &&
                !this.isDataRowWithoutSubs() &&
                this.dataRow.expanded));
    };
    SisChangeLogDiffTreeNodeComponent.prototype.isEqual = function () {
        return !lodash_1.isNil(this.dataRow) && this.dataRow.equal;
    };
    SisChangeLogDiffTreeNodeComponent.prototype.isDataRowWithoutSubs = function () {
        return (!lodash_1.isNil(this.dataRow) &&
            this.dataRow.childGroups.length === 0 &&
            this.dataRow.fieldPartRows.length === 0);
    };
    SisChangeLogDiffTreeNodeComponent.prototype.toggleRow = function () {
        if (!lodash_1.isNil(this.dataRow)) {
            this.dataRow.expanded = !this.dataRow.expanded;
        }
        if (!lodash_1.isNil(this.group)) {
            this.group.expanded = !this.group.expanded;
        }
        if (!lodash_1.isNil(this.subGroup)) {
            this.subGroup.expanded = !this.subGroup.expanded;
        }
    };
    SisChangeLogDiffTreeNodeComponent.prototype.ngOnInit = function () { };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "rowLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "dataRow", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "group", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "subGroup", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "linked", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisChangeLogDiffTreeNodeComponent.prototype, "createVersion", void 0);
    SisChangeLogDiffTreeNodeComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-change-log-diff-node',
            template: require('./sis-change-log-diff-node.component.html'),
        })
    ], SisChangeLogDiffTreeNodeComponent);
    return SisChangeLogDiffTreeNodeComponent;
}());
exports.SisChangeLogDiffTreeNodeComponent = SisChangeLogDiffTreeNodeComponent;
//# sourceMappingURL=sis-change-log-diff-node.component.js.map